import request from '@/config/axios'
import type { AgentOperateLogVO } from './dashboard'

export const getAgentOperateLogPage = (params: any) =>
  request.get<{ list: AgentOperateLogVO[]; total: number }>({ url: '/agent/operate-log/page', params })
